var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgG09(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.945,
    height: 80.947,
    viewBox: "0 0 80.945 80.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.945,
    height: 80.947,
    transform: "translate(0 0)",
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80.945,
    height: 80.947,
    transform: "translate(0 0)",
    fill: "#fc6926"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.106,13.393c-.048.914-.433,1.491-1.3,1.491-.937,0-1.3-.577-1.3-1.636V10.409c0-1.034.384-1.635,1.323-1.635.915,0,1.275.625,1.275,1.635Zm2.72-2.5c0-2.527-1.108-4.355-3.995-4.355C7.92,6.536,6.79,8.123,6.79,10.65v2.406c0,2.671,1.057,4.018,3.031,4.018a2.348,2.348,0,0,0,2.262-1.323h.023v3.512c0,.986-.385,1.685-1.371,1.685s-1.347-.578-1.347-1.589V18.277h-2.5v.867c0,2.405.867,4.089,3.9,4.089,2.886,0,4.042-1.852,4.042-4.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.166,64.883l-8.638,4.986V59.9l8.638-4.987ZM31.63,69.869V60.655l7.98,4.607Zm-1.312,0-8.637-4.986V54.91L30.318,59.9ZM39.61,42.285l-7.98,4.608V37.678Zm10.6,4.608-7.979-4.608,7.979-4.607Zm-7.979,6.88,8.635-4.985,8.638,4.985L50.871,58.76Zm-1.969-1.137-7.98-4.606,7.98-4.608Zm9.291-4.606-7.979,4.606V43.422Zm-9.291,16.1-7.98-4.608,7.98-4.608ZM61.15,53.2l-9.622-5.553V36.541a.655.655,0,0,0-.329-.568l-9.948-5.744a.657.657,0,0,0-.656,0l-9.949,5.744a.656.656,0,0,0-.328.568v11.11L20.7,53.2a.654.654,0,0,0-.328.569V65.262a.654.654,0,0,0,.328.569l9.949,5.743a.655.655,0,0,0,.656,0l9.621-5.554,9.62,5.554a.664.664,0,0,0,.328.088.648.648,0,0,0,.328-.088l9.951-5.743a.656.656,0,0,0,.328-.569V53.773a.656.656,0,0,0-.328-.569",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.06,
    height: 6.307,
    transform: "translate(19.115 6.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.544,9.259v3.963h-.893V6.915h1.042l1.144,3.618V6.915h.884v6.307h-.93Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.694,12.357c.437,0,.6-.261.6-.642v-3.3a.553.553,0,0,0-.6-.633h-.447v4.577Zm1.665-3.749v2.921c0,.967-.4,1.693-1.535,1.693H24.187V6.915h1.637c1.135,0,1.535.716,1.535,1.693",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.905,6.915v4.772c0,.977-.419,1.609-1.5,1.609a1.423,1.423,0,0,1-1.581-1.609V6.915h1.06v4.874c0,.372.149.624.521.624s.521-.252.521-.624V6.915Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.315,11.863v-.846H32.3v.865c0,.353.158.558.521.558.335,0,.483-.223.483-.558V11.64a1.138,1.138,0,0,0-.474-.893l-.623-.623a2.128,2.128,0,0,1-.884-1.684V8.226A1.316,1.316,0,0,1,32.813,6.84c1.06,0,1.479.521,1.479,1.432v.512h-.968V8.235c0-.363-.167-.539-.5-.539a.465.465,0,0,0-.5.52v.131c0,.353.195.558.5.856l.679.669a2.119,2.119,0,0,1,.856,1.638v.307A1.366,1.366,0,0,1,32.813,13.3a1.314,1.314,0,0,1-1.5-1.433",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.423,6.915h2.819V7.78h-.875v5.442H35.3V7.78h-.874Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.656,7.78V9.743h.354a.458.458,0,0,0,.52-.521v-.93c0-.344-.157-.512-.52-.512Zm0,2.549v2.893H37.6V6.915H39.14c1.07,0,1.46.53,1.46,1.414v.809c0,.679-.241,1.079-.846,1.219l1.014,2.865H39.652Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.872,10.822v2.4H41.811v-2.4L40.63,6.915h1.107l.642,2.391h.009l.642-2.391h1.014Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.957,12.291l-.539,1.423h-.6l.13-1.506h1.005Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.061,
    height: 6.307,
    transform: "translate(46.26 6.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.688,9.259v3.963H47.8V6.915h1.042l1.144,3.618V6.915h.884v6.307h-.93Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.225,9.259v3.963h-.893V6.915h1.042l1.144,3.618V6.915H54.4v6.307h-.93Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.017,11.761V8.375c0-.381-.167-.651-.549-.651s-.539.27-.539.651v3.386c0,.382.167.652.539.652s.549-.27.549-.652m-2.149-.167V8.543a1.608,1.608,0,1,1,3.21,0v3.051a1.608,1.608,0,1,1-3.21,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.939,6.915l-1.2,6.307H59.585l-1.2-6.307h1.078l.726,4.4H60.2l.744-4.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.935,11.222h.847l-.419-2.53h-.009Zm-1.33,2L62.8,6.915H64l1.2,6.307H64.117l-.2-1.153H62.8l-.186,1.153Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.918,6.915h2.819V7.78h-.875v5.442h-1.07V7.78h-.874Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.061,
    height: 6.307,
    transform: "translate(68.09 6.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.775,11.761V8.375c0-.381-.167-.651-.549-.651s-.539.27-.539.651v3.386c0,.382.167.652.539.652s.549-.27.549-.652m-2.149-.167V8.543a1.608,1.608,0,1,1,3.21,0v3.051a1.608,1.608,0,1,1-3.21,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.195,9.259v3.963H73.3V6.915h1.042l1.144,3.618V6.915h.884v6.307h-.93Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.274,20.944h.847l-.419-2.53h-.009Zm-1.33,2,1.191-6.307h1.209l1.2,6.307H21.456l-.2-1.154H20.135l-.186,1.154Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.828,18.982v3.963h-.893V16.638h1.042l1.144,3.618V16.638H26v6.307h-.93Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.072,22.08c.437,0,.6-.261.6-.642v-3.3a.553.553,0,0,0-.6-.633h-.447V22.08Zm1.665-3.749v2.921c0,.967-.4,1.693-1.535,1.693H26.565V16.638H28.2c1.135,0,1.535.716,1.535,1.693",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.061,
    height: 6.307,
    transform: "translate(31.227 16.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.748,18.982v3.963h-.893V16.638H33.9l1.144,3.618V16.638h.884v6.307h-.93Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.485,16.638h2.484V17.5H37.544v1.805h1.061v.855H37.544v2.782h-1.06Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.448,17.5v1.963H40.8a.458.458,0,0,0,.52-.521v-.93c0-.344-.157-.512-.52-.512Zm0,2.549v2.893H39.387V16.638h1.545c1.07,0,1.46.53,1.46,1.414v.809c0,.679-.241,1.079-.846,1.219l1.014,2.865H41.444Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.087,20.944h.847l-.419-2.53h-.009Zm-1.33,2,1.191-6.307h1.209l1.2,6.307H45.269l-.2-1.154H43.948l-.186,1.154Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6,21.586V20.74h.986V21.6c0,.353.158.558.521.558.335,0,.483-.224.483-.558v-.242a1.138,1.138,0,0,0-.474-.893l-.623-.623a2.128,2.128,0,0,1-.884-1.684v-.214A1.316,1.316,0,0,1,48.1,16.563c1.06,0,1.479.521,1.479,1.432v.512h-.968v-.549c0-.363-.167-.539-.5-.539a.465.465,0,0,0-.5.52v.131c0,.353.195.558.5.856l.679.669a2.119,2.119,0,0,1,.856,1.638v.307A1.366,1.366,0,0,1,48.1,23.019a1.314,1.314,0,0,1-1.5-1.433",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.893,16.638h2.819V17.5h-.875v5.442h-1.07V17.5h-.874Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.219,17.5v1.963h.354a.459.459,0,0,0,.52-.521v-.93c0-.344-.158-.512-.52-.512Zm0,2.549v2.893h-1.06V16.638H54.7c1.07,0,1.46.53,1.46,1.414v.809c0,.679-.241,1.079-.846,1.219l1.014,2.865H55.215Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.775,16.638V21.41c0,.977-.419,1.609-1.5,1.609A1.423,1.423,0,0,1,56.7,21.41V16.638h1.06v4.874c0,.372.149.624.521.624s.521-.252.521-.624V16.638Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.334,21.317V18.266a1.488,1.488,0,0,1,1.582-1.7c1.172,0,1.5.652,1.5,1.582v.744h-.967v-.828c0-.391-.13-.614-.512-.614s-.539.27-.539.651v3.387c0,.381.158.651.539.651s.512-.242.512-.614V20.359h.967v1.088c0,.9-.372,1.572-1.5,1.572a1.491,1.491,0,0,1-1.582-1.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.591,16.638H66.41V17.5h-.875v5.442h-1.07V17.5h-.874Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.936,16.638V21.41c0,.977-.419,1.609-1.5,1.609a1.423,1.423,0,0,1-1.581-1.609V16.638h1.06v4.874c0,.372.149.624.521.624s.521-.252.521-.624V16.638Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.556,17.5v1.963h.354a.458.458,0,0,0,.52-.521v-.93c0-.344-.157-.512-.52-.512Zm0,2.549v2.893H70.5V16.638H72.04c1.07,0,1.46.53,1.46,1.414v.809c0,.679-.241,1.079-.846,1.219l1.014,2.865H72.552Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.031,16.638h2.53V17.5H75.092v1.805h1.051v.855H75.092V22.08h1.469v.865h-2.53Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG09);
export default __webpack_public_path__ + "static/media/G09.5ca0e54be9f3bc45267f70222d851327.svg";
export { ForwardRef as ReactComponent };